var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransferencia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "19.2 Transferencia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Michelle-Pourroy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.7.1-Productos",
    transform: "translate(-219.000000, -457.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(195.000000, 430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "19.2-Transferencia",
    transform: "translate(25.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1648316,10.8946988 C12.0788365,10.4448332 12.0788365,10.2749082 12.0788365,10.1104295 C12.0788365,9.85009564 12.3141173,9.69977735 12.7236801,9.69977735 C13.3478278,9.69977735 13.7247128,9.91654068 13.9055304,10.0200207 L14.5166069,10.3707633 L15.2398775,8.46237468 L14.803083,8.20530863 C14.4294659,7.98636679 14.0231708,7.84149482 13.5711267,7.76742494 L13.5711267,6.57250352 L11.6420421,6.57250352 L11.6420421,7.89051165 C10.5625825,8.25105767 9.86763277,9.15078884 9.86763277,10.2509444 C9.86763277,11.7334312 11.0407689,12.3935245 12.1812272,12.8401223 C13.1343323,13.2268107 13.1343323,13.5111083 13.1343323,13.6821226 C13.1343323,14.0895069 12.7040734,14.2332896 12.3359025,14.2332896 C11.8642517,14.2332896 11.3566552,14.0818821 10.9775917,13.8291731 L10.3381944,13.402182 L9.64324461,15.3399807 L10.013594,15.6046716 C10.4068179,15.8857015 10.9677883,16.0926614 11.5603473,16.1830702 L11.5603473,17.4193837 L13.5003246,17.4193837 L13.5003246,16.0676084 C14.6298902,15.6950805 15.3575179,14.752868 15.3575179,13.6004279 C15.3575179,11.9948543 14.1843817,11.3107972 13.1648316,10.8946988",
    id: "Fill-1",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04601918,7.48650403 C2.9783716,3.07825701 7.38008305,0 12.500708,0 C19.4044564,0 25.0010893,5.59663287 25.0010893,12.5003812 C25.0010893,12.6060397 25,12.7127875 24.9967322,12.818446",
    id: "Stroke-3",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "5.20820171 6.55463961 0.932844763 7.48813793 0.000435705167 3.21278098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9550701,17.513496 C22.0227177,21.921743 17.6210062,25 12.5003812,25 C5.59663287,25 0,19.4033671 0,12.4996188 C0,12.330783 0.00326778875,12.1630365 0.00980336626,11.9963793",
    id: "Stroke-7",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "19.7927786 18.4454693 24.0681356 17.511971 25.0005446 21.787328"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferencia);
export default __webpack_public_path__ + "static/media/Transferencia.ae8df94d65218777c649df83c2b62a82.svg";
export { ForwardRef as ReactComponent };